import interfaceClass from './Interface.js'
import config from './config.js'
class centralControl{
    centralControl(str,fun,data){
        interfaceClass[str](config.getStr("url"),fun,{...data,...this.getData(str)});
    }
    getData(str) {
        const loginInfo = localStorage.getItem("loginInfo");
        const currentLoginInfo = loginInfo ? JSON.parse(loginInfo): {};
        return {
            url:config.getStr(str),
            userId: currentLoginInfo.id,
            unitCode:currentLoginInfo.unitCode,
            hospitalCode: currentLoginInfo.hospitalCode,
        }
    }
}
let centralcontrol = new centralControl();
export default centralcontrol